module.exports = __webpack_public_path__ + "media/Hud.8d2f24ae.wav";